module.exports = __webpack_public_path__ + "img/logo-opm.53b13133.png";